export const CustomFieldSchemas = {
  textarea: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
};
